import { TriangleAlert } from "lucide-react";
import type { FC } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";

import { moveWarningText, type MoveWarning } from "./crossDrop";

type Props = {
  warning: MoveWarning | null;
  pending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

/**
 * Asked before a case file leaves Case Files and becomes a draft Casey can edit.
 */
export const MoveToWorkProductsDialog: FC<Props> = ({
  warning,
  pending,
  onOpenChange,
  onConfirm
}) => (
  <AlertDialog open={warning !== null} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader className="sm:grid-cols-[auto_minmax(0,1fr)]">
        <AlertDialogMedia className="bg-warn-soft text-warn">
          <TriangleAlert aria-hidden />
        </AlertDialogMedia>
        <AlertDialogTitle>Move to Work Products</AlertDialogTitle>
        <AlertDialogDescription>
          {warning ? moveWarningText(warning) : ""}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={pending}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          disabled={pending}
          onClick={(event) => {
            event.preventDefault();
            onConfirm();
          }}
        >
          Move
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
